<div>
  <div class="header subtitle-box">
    <div class="header-content">
      <div class="info-content">
        <mat-icon aria-hidden="false" aria-label="Info">info</mat-icon>
        <span>Clique no horário para visualizar mais detalhes</span>
      </div>
      <button mat-flat-button type="button" color="primary" class="btn-block" (click)="changeShowSubtitle()">
        <span>Legenda</span>
      </button>
    </div>
    <div class="floating-subtitle"
      [ngClass]="{'floating-subtitle-visible': this.showSubtitle, 'floating-subtitle-hide': !this.showSubtitle}">
      <div>
        <h1>Legenda do Planejamento Terapêutico</h1>
        <div class="status">
          @for (status of listStatusScheduling; track status) {
            <div class="status-content">
              <span class="status-subtitle" [style.background-color]="status.color"
              [style.border-color]="status.color"></span>
              <span>{{status.name}}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  @if (listPrescriptionMedicine && listPrescriptionMedicine.length > 0) {
    <div class="table-content">
      <table>
        <thead>
          <tr class="header-table">
            <th>Lista de prescrições solicitadas no episódio</th>
            @for (datetime of listDateTime; track datetime) {
              <th [attr.colspan]="datetime.hour.length"
              class="date-segment">{{ datetime.date }}</th>
            }
          </tr>
          <tr class="header-table">
            <th class="header-table header-prescription">
              <span>Material prescrito</span>
              <span>Hora:</span>
            </th>
            @for (datetime of listDateTime; track datetime) {
              @for (hour of datetime.hour; track hour) {
                <th class="hour-segment">
                  {{ hour }}
                </th>
              }
            }
          </tr>
        </thead>
        <tbody class="table-body-content">
          @for (item of listPrescriptionMedicine; track item) {
            <tr>
              <td class="prescription-content">
                <p
                  [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescricaoSuspenso}">
                  <b>{{ item.medicineName }}</b>
                </p>
                <div class="tag-container">
                  @for (tag of medicineTagUtilsService.getMainTags(item.listTags); track tag) {
                                <span class="tag-header-prescription" [ngStyle]="tag.colorCode ? {'background-color': tag.colorCode, 
                                    'color': 'white' } : {}">{{tag.tagName}}</span>
                  }
                  @if (medicineTagUtilsService.getExtraTags(item.listTags).length > 0) {
                    <span
                      class="tag-header-prescription more-tags"
                      matTooltip="{{ medicineTagUtilsService.getTooltipText(item.listTags) }}"
                      matTooltipClass="tag-tooltip">
                      +{{ medicineTagUtilsService.getExtraTags(item.listTags).length }}
                    </span>
                  }
                </div>
                <span
                  [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Quantidade:
                </b>{{item.prescriptionMedicine.quantity}}</span> | <span
                [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Via:
              </b>{{item.usage}}</span> | <span
              [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Frequência:
            </b>{{item.frequencyName}}</span> | <span
            [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Diluição:
          </b>{{item.dilutionName}}</span>
          <p
            [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescricaoSuspenso}">
            <b>Local de Administração: </b>{{item.lookupAdministrationLocationName}}
          </p>
          <p
            [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescricaoSuspenso}">
            <b>Observação: </b>{{item.prescriptionMedicine.observation}}
          </p>
          <span
            [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Médico
          responsável: </b>{{item.userName}}</span> | <span
          [ngClass]="{'text-tacked': item.prescriptionMedicine.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Data
        e hora atendimento: </b>{{item.datetimeMedicalAttendance | date:'dd/MM/yy H:mm'}}</span>
        @if (item.prescriptionMedicine.motiveSuspended && item.prescriptionMedicine.idPrescriptionStatus === this.prescricaoSuspenso) {
          <p
            [matTooltip]="item.prescriptionMedicine.motiveSuspended">
            <b>Motivo da Suspensão: </b>{{item.prescriptionMedicine.motiveSuspended | truncateText:50}}
          </p>
        }
        @if (item.prescriptionMedicine.idPrescriptionStatus === this.prescricaoSuspenso) {
          <p>
            <b> Responsável pela suspensão: </b>
            @if (item.prescriptionMedicine.idMedicalCareSuspended) {
              <span
              [matTooltip]="item.medicNameSuspended">{{ item.medicNameSuspended }}</span>
            }
            @if (item.prescriptionMedicine.idUserNurseSuspended) {
              <span
              [matTooltip]="item.nurseNameSuspended"> {{ item.nurseNameSuspended }}</span>
            }
            @if (item.prescriptionMedicine.datetimeSuspended) {
              <span
                [matTooltip]="item.prescriptionMedicine.datetimeSuspended | date:'dd/MM/yyyy HH:mm'">;
              {{ item.prescriptionMedicine.datetimeSuspended | date:'dd/MM/yyyy HH:mm' }}</span>
            }
          </p>
        }
        <div class="button-row row">
          @if (isToDisplayLatePendingPrescriptionsCheckButton(item)) {
            <button mat-flat-button
              type="button" color="accent" class="btn-block late-button col-md-6"
              (click)="openLatePendingPrescriptionChecksModal(item)">
              @if (isLoading == false) {
                <span>
                  <mat-icon aria-hidden="false" aria-label="Info">warning</mat-icon>
                Concluir checagens atrasadas</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"
                ></mat-spinner>
              }
            </button>
          }
          @if (isChecking && item.prescriptionMedicine.idPrescriptionStatus == prescriptionStatusEnum.EmAberto) {
            <button mat-flat-button type="button"
              class="col-md-6" color="accent" (click)="openReleasePrescriptionModal(item)">
              @if (!isLoadingRelease) {
                <span aria-hidden="false"
                  aria-label="Liberar Prescrição">Liberar prescrição
                </span>
              }
              @if (isLoadingRelease) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"
                ></mat-spinner>
              }
            </button>
          }
        </div>
      </td>
      @for (datetime of listDateTime; track datetime) {
        @for (hour of datetime.hour; track hour) {
          <td class="action-segment">
            <button type="button" class="scheduling-button"
              [ngClass]="item.listPrescriptionMedicineCheck | filterStatusPrescriptionScheduling:item.prescriptionMedicine.idPrescriptionStatus:isChecking:item.prescriptionMedicine.idFrequency:'getStatusPrescription':null:listDateTime:datetime.date:hour"
              [matTooltip]="getReasonSuspensionByDateTime(item, datetime.date, hour, false)"
              (click)="openPrescriptionSchedulingModal(item, datetime.date, hour)">
            </button>
          </td>
        }
      }
    </tr>
  }
</tbody>
</table>
@if (listStatusScheduling && listStatusScheduling.length > 0) {
  <app-subtitle-info class="subtitle-container"
  [listStatusScheduling]="listStatusScheduling"></app-subtitle-info>
}
</div>
}

@if (listPrescriptionSolution && listPrescriptionSolution.length > 0) {
  <div class="table-content">
    <table>
      <thead>
        <tr class="header-table">
          <th>Lista de prescrições solicitadas no episódio</th>
          @for (datetime of listDateTime; track datetime) {
            <th [attr.colspan]="datetime.hour.length"
            class="date-segment">{{ datetime.date }}</th>
          }
        </tr>
        <tr class="header-table">
          <th class="header-table header-prescription">
            <span>Material prescrito</span>
            <span>Hora:</span>
          </th>
          @for (datetime of listDateTime; track datetime) {
            @for (hour of datetime.hour; track hour) {
              <th class="hour-segment">
                {{ hour }}
              </th>
            }
          }
        </tr>
      </thead>
      <tbody class="table-body-content">
        @for (item of listPrescriptionSolution; track item) {
          <tr>
            <td class="prescription-content">
              @for (medicine of item.listSolutionMedicine; track medicine) {
                <p [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescricaoSuspenso}"><b>{{
                medicine.medicineName }}</b> | <span><b>Quantidade:
              </b>{{medicine.prescriptionSolutionMedicine.quantity}}</span></p>
              <div class="tag-container">
                @for (tag of medicineTagUtilsService.getMainTags(medicine.listTags); track tag) {
                                    <span class="tag-header-prescription" [ngStyle]="tag.colorCode ? {'background-color': tag.colorCode, 
                                        'color': 'white' } : {}">{{tag.tagName}}</span>
                }
                @if (medicineTagUtilsService.getExtraTags(medicine.listTags).length > 0) {
                  <span
                    class="tag-header-prescription more-tags"
                    matTooltip="{{ medicineTagUtilsService.getTooltipText(medicine.listTags) }}"
                    matTooltipClass="tag-tooltip">
                    +{{ medicineTagUtilsService.getExtraTags(medicine.listTags).length }}
                  </span>
                }
              </div>
            }
            <span [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Via:
            </b>{{item.usage}}</span> | <span
            [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Frequência:
          </b>{{item.frequencyName}}</span> | <span
          [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Diluição:
        </b>{{item.dilutionName}}</span>
        <p [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Local de
        Administração: </b>{{item.lookupAdministrationLocationName}}</p>
        <p [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescricaoSuspenso}">
          <b>Observação: </b>{{item.prescriptionSolution.observation}}
        </p>
        <span [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Médico
        responsável: </b>{{item.userName}}</span> | <span
        [ngClass]="{'text-tacked': item.idPrescriptionStatus == this.prescricaoSuspenso}"><b>Data e
      hora atendimento: </b>{{item.datetimeMedicalAttendance | date:'dd/MM/yy H:mm'}}</span>
      @if (item.motiveSuspended && item.idPrescriptionStatus === this.prescricaoSuspenso) {
        <p
          [matTooltip]="item.motiveSuspended">
          <b>Motivo da Suspensão: </b>{{item.motiveSuspended | truncateText:50}}
        </p>
      }
      @if (item.idPrescriptionStatus === this.prescricaoSuspenso) {
        <p>
          <b> Responsável pela suspensão: </b>
          @if (item.idMedicalCareSuspended) {
            <span [matTooltip]="item.medicNameSuspended">{{
            item.medicNameSuspended }}</span>
          }
          @if (item.idUserNurseSuspended) {
            <span [matTooltip]="item.nurseNameSuspended"> {{
            item.nurseNameSuspended }}</span>
          }
          @if (item.datetimeSuspended) {
            <span
              [matTooltip]="item.datetimeSuspended | date:'dd/MM/yyyy HH:mm'">; {{
            item.datetimeSuspended | date:'dd/MM/yyyy HH:mm' }}</span>
          }
        </p>
      }
      <div class="button-row row">
        @if (isToDisplayLatePendingSolutionCheckButton(item)) {
          <button mat-flat-button
            type="button" color="accent" class="btn-block late-button col-md-6"
            (click)="openLatePendingSolutionChecksModal(item)">
            @if (isLoading == false) {
              <span>
                <mat-icon aria-hidden="false" aria-label="Info">warning</mat-icon>
              Concluir checagens atrasadas</span>
            }
            @if (isLoading == true) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"
              ></mat-spinner>
            }
          </button>
        }
        @if (isChecking && item.idPrescriptionStatus == prescriptionStatusEnum.EmAberto) {
          <button mat-flat-button type="button"
            class="col-md-6" color="accent" (click)="openReleasePrescriptionSolutionModal(item)">
            @if (!isLoadingRelease) {
              <span aria-hidden="false"
                aria-label="Liberar Prescrição">Liberar prescrição
              </span>
            }
            @if (isLoadingRelease) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"
              ></mat-spinner>
            }
          </button>
        }
      </div>
    </td>
    @for (datetime of listDateTime; track datetime) {
      @for (hour of datetime.hour; track hour) {
        <td class="action-segment">
          <button type="button" class="scheduling-button"
            [ngClass]="item.listSolutionCheck | filterStatusPrescriptionScheduling:item.idPrescriptionStatus:isChecking:item.prescriptionSolution.idFrequency:'getStatusPrescriptionSolution':null:listDateTime:datetime.date:hour"
            [matTooltip]="getReasonSuspensionByDateTime(item, datetime.date, hour, false)"
            (click)="openMedicatedSolutionSchedulingModal(item, datetime.date, hour)">
          </button>
        </td>
      }
    }
  </tr>
}
</tbody>
</table>
@if (listStatusScheduling && listStatusScheduling.length > 0) {
  <app-subtitle-info class="subtitle-container"
  [listStatusScheduling]="listStatusScheduling"></app-subtitle-info>
}
</div>
}

@if (listMedicalProcedureStruct && listMedicalProcedureStruct.length > 0) {
  <div class="table-content">
    <table>
      <thead>
        <tr class="header-table">
          <th>Lista de procedimentos solicitados no episódio</th>
          @for (datetime of listDateTime; track datetime) {
            <th [attr.colspan]="datetime.hour.length"
            class="date-segment">{{ datetime.date }}</th>
          }
        </tr>
        <tr class="header-table">
          <th class="header-table header-prescription">
            <span>Material prescrito</span>
            <span>Hora:</span>
          </th>
          @for (datetime of listDateTime; track datetime) {
            @for (hour of datetime.hour; track hour) {
              <th class="hour-segment">
                {{ hour }}
              </th>
            }
          }
        </tr>
      </thead>
      <tbody class="table-body-content">
        @for (item of listMedicalProcedureStruct; track item) {
          <tr>
            <td class="prescription-content">
              <p><b>{{ item.procedureName }}</b></p>
              <p><b>Observação: </b>{{item.observation}}</p>
              <span><b>Médico responsável: </b>{{item.userName}}</span> | <span><b>Data e hora atendimento:
            </b>{{item.datetimeMedicalAttendance | date:'dd/MM/yy H:mm'}}</span>
            @if (isToDisplayLatePendingProcedureCheckButton(item)) {
              <button mat-flat-button type="button"
                color="accent" class="btn-block late-button"
                (click)="openLatePendingProcedureChecksModal(item)">
                @if (isLoading == false) {
                  <span>
                    <mat-icon aria-hidden="false" aria-label="Info">warning</mat-icon>
                  Concluir checagens atrasadas</span>
                }
                @if (isLoading == true) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"
                  ></mat-spinner>
                }
              </button>
            }
          </td>
          @for (datetime of listDateTime; track datetime) {
            @for (hour of datetime.hour; track hour) {
              <td class="action-segment">
                <button type="button" class="scheduling-button"
                  [ngClass]="item.listMedicalProcedureCheck | filterStatusPrescriptionScheduling:null:isChecking:null:'getStatusProcedure':item.isRecurring:listDateTime:datetime.date:hour"
                  [matTooltip]="getReasonSuspensionByDateTime(item, datetime.date, hour, true)"
                  (click)="openProcedureSchedulingModal(item, datetime.date, hour)">
                </button>
              </td>
            }
          }
        </tr>
      }
    </tbody>
  </table>
  @if (listStatusScheduling && listStatusScheduling.length > 0) {
    <app-subtitle-info class="subtitle-container"
    [listStatusScheduling]="listStatusScheduling"></app-subtitle-info>
  }
</div>
}

@if (listSadtGroup && listSadtGroup.length > 0) {
  <div class="table-content">
    <table>
      <thead>
        <tr class="header-table">
          <th>Lista de exames solicitados no episódio</th>
          @for (datetime of listDateTime; track datetime) {
            <th [attr.colspan]="datetime.hour.length"
            class="date-segment">{{ datetime.date }}</th>
          }
        </tr>
        <tr class="header-table">
          <th class="header-table header-prescription">
            <span>Material prescrito</span>
            <span>Hora:</span>
          </th>
          @for (datetime of listDateTime; track datetime) {
            @for (hour of datetime.hour; track hour) {
              <th class="hour-segment">
                {{ hour }}
              </th>
            }
          }
        </tr>
      </thead>
      <tbody class="table-body-content">
        @for (item of listSadtGroup; track item) {
          <tr>
            <td class="prescription-content">
              <p [ngClass]="{'text-tacked': item.idStatus == this.sadtStatusEnum.Suspenso}"><b>{{
              item.typeSadtName }}</b></p>
              <p [ngClass]="{'text-tacked': item.idStatus == this.sadtStatusEnum.Suspenso}"><b>Observação:
              </b>{{item.observation}}</p>
              <span [ngClass]="{'text-tacked': item.idStatus == this.sadtStatusEnum.Suspenso}"><b>Médico
              responsável: </b>{{item.userName}}</span> | <span
              [ngClass]="{'text-tacked': item.idStatus == this.sadtStatusEnum.Suspenso}"><b>Data e hora
            atendimento: </b>{{item.datetimeMedicalAttendance | date:'dd/MM/yy H:mm'}}</span>
            @if (item.motiveSuspended) {
              <p [matTooltip]="item.motiveSuspended" class="secundary"><b>Motivo
              da suspensão: </b>{{item.motiveSuspended | truncateText:50}}</p>
            }
            @if (item.medicNameSuspended || item.nurseNameSuspended) {
              <p class="secundary"
                [matTooltip]="item.medicNameSuspended ? item.medicNameSuspended : item.nurseNameSuspended">
                <b>Responsável pela suspensão: </b>{{item.medicNameSuspended ? item.medicNameSuspended :
                item.nurseNameSuspended}}; {{ item.datetimeSuspended | date:'dd/MM/yyyy HH:mm' }}
              </p>
            }
          </td>
          @for (datetime of listDateTime; track datetime) {
            @for (hour of datetime.hour; track hour) {
              <td class="action-segment">
                <button type="button" class="scheduling-button"
                  [ngClass]="item.datetimeCheckEstimative | filterStatusSadtScheduling:item.idStatus:item.idStatusScheduling:listDateTime:datetime.date:hour"
                  (click)="openSadtSchedulingModal(item)">
                </button>
              </td>
            }
          }
        </tr>
      }
    </tbody>
  </table>
  @if (listStatusScheduling && listStatusScheduling.length > 0) {
    <app-subtitle-info class="subtitle-container"
    [listStatusScheduling]="listStatusScheduling"></app-subtitle-info>
  }
</div>
}

</div>